import { render, staticRenderFns } from "./PFInternationalBank.vue?vue&type=template&id=84d3a300"
import script from "./PFInternationalBank.vue?vue&type=script&lang=js"
export * from "./PFInternationalBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports